<template>
  <div class="groups-display">
    <div class="group-card" v-for="group in groups" :key="group.id">
      <h2>{{ group.name }}</h2>
      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th>POS</th>
            <th>JOGADOR</th>
            <th>VITÓRIAS</th>
            <th>JOGOS</th>
            <th>SALDO DE SETS</th>
            <th>SALDO DE GAMES</th>
            <th>GAMES GANHOS</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(player, index) in groupPlayersMap[group.id]"
              :key="player.id"
          >
            <td :class="getRowClass(index, groupPlayersMap[group.id].length)">
              {{ index + 1 }}
            </td>
            <td>{{player?.User?.fullName }}</td>
            <td>{{ player.victories }}</td>
            <td>{{ player.jogos }}</td>
            <td>{{ player.setAverage }}</td>
            <td>{{ player.games }}</td>
            <td>{{ player.gamesWon }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GroupsDisplay',
  props:{
    groups: {
      type: Array,
      default: () => []
    },
    groupPlayersMap: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatarMedia(valor) {
      if(!valor) return 0.0;
      return (Math.ceil(valor * 10) / 10).toFixed(1);
    },
    getRowClass(index, totalPlayers) {
      const lastIndex = totalPlayers - 1;
      const secondLastIndex = lastIndex - 1;

      if (index === 0 || index === 1) {
        return 'green';
      }

      if (index === lastIndex || index === secondLastIndex) {
        return 'red';
      } else {
        return 'black';
      }
    },
  },
};
</script>

<style scoped>
.groups-display {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.group-card {
  flex: 1 1 calc(33% - 20px);
  margin: 10px;
  box-sizing: border-box;
  background-color: white;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.group-card h2 {
  text-align: center;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  text-transform: uppercase;
  border-bottom: 1px solid black;
  padding-bottom: 0.5rem;
}

.table-wrapper {
  overflow-x: auto;
}

.group-card table {
  width: 100%;
  border-collapse: collapse;
}

.group-card th,
.group-card td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: center;
}

.group-card th {
  background-color: #0056B3;
  color: white;
}

@media (max-width: 900px) {
  .group-card {
    flex: 1 1 calc(50% - 20px);
  }
}

@media (max-width: 600px) {
  .groups-display {
    flex-direction: column;
    align-items: center;
  }

  .group-card {
    flex: 1 1 100%;
  }
}
</style>
